import { useQuery } from 'react-query';
import { ReportPreferences } from '@tcs/client-portal-api/types/ReportPreferences';

export const useReportPreferences = (representativeCode: string) => {
  return useQuery<ReportPreferences, Error>(
    `/rss/reportpreferences/${representativeCode}`,
    {
      refetchOnMount: false,
      enabled: representativeCode !== undefined,
    }
  );
};

export default useReportPreferences;
